import React from 'react';
import './modal.css';
import { useDispatch, useSelector } from 'react-redux';
import { setModal } from '../../features/dialogControl/dialogControlSlice';
import { IconButton } from "@mui/material";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';


const Modal = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const modal = useSelector((state) => state.dialogControl.modal);
    
    const handleCloseModal = (e) => {
        e.stopPropagation();
        let m = {
            visible: false,
            title: '',
            copy: ''
        }
        if (e.target.id !== 'modal-container') dispatch(setModal(m));
    }


    return (
        <div className='screen'>
            <motion.div
                id='modal-container'
                className="modal-container"
                initial={{ opacity: 0, y: 30 }}  
                animate={{ opacity: 1, y: 0 }}  
                exit={{ opacity: 0, y: 30 }}  
                transition={{ duration: 0.35, ease: "easeInOut" }}  
            >
                {/* <div id='modal-container' className='modal-container'> */}
                    <div className='modal-header'>
                        <div className='modal-title'>{modal.title}</div>
                        <div className='modal-close-button'>
                            <IconButton
                                onClick={(event) => handleCloseModal(event)}
                            >
                                <CancelOutlinedIcon 
                                    sx= {{
                                        color:theme.palette.color
                                    }}
                                />
                            </IconButton>
                        </div>
                    </div>
                    <div className='modal-copy'>{modal.copy}</div>
                {/* </div> */}
            </motion.div>
        </div>
    );
}

export default Modal;